// extracted by mini-css-extract-plugin
export default {"body":"ConfirmBusyTable_body__WhOoU","footer":"ConfirmBusyTable_footer__E6-uf"};